module.exports = __webpack_public_path__ + "static/media/ky.5814c5a9.svg";